import React, { Component } from 'react';
import PropTypes from 'prop-types';
import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';

const getCommunities = ComposedComponent => {
  class GetCommunities extends Component {
    componentWillMount() {
      this.props.dispatchCommunitiesGet();
    }

    render() {
      return <ComposedComponent {...this.props} />;
    }
  }

  GetCommunities.propTypes = {
    dispatchCommunitiesGet: PropTypes.func.isRequired,
  };

  return reduxFetch(() => [
    {
      resource: 'communities',
      method: 'get',
      request: () => ({
        url: apiRoutes.getCommunities(),
      }),
    },
  ])(GetCommunities);
};

export default getCommunities;
